"use client";

import { createContext, useContext } from "react";

/**
 * The legacy (V1) landing page a component is rendered on, so a form modal opened from any of the
 * page's buttons can name it to the server without every component passing it down. The server checks
 * the id (same event, and the page links the form); it never trusts it. Null outside a public legacy
 * page, such as the builder preview.
 */
export const LegacyLandingPageIdContext = createContext<number | null>(null);

/**
 * The `landing_pages` id of the public legacy page this component is on.
 *
 * @returns The page id, or null outside a public legacy page.
 * @throws Never.
 */
export function useLegacyLandingPageId(): number | null {
  return useContext(LegacyLandingPageIdContext);
}
